<template>
    <div>
        <div v-if="isLoaded" id="offer">
            <header :style="{backgroundColor:theme.mainColor}">
                <div class="logo-row">
                    <span class="logo"><img :src="logo === `/${baseUrl}/static/uploads/` ? '' : logo"></span>
                    <nav class="header-nav hide-mobile">
                        <b-nav v-b-scrollspy="{offset:0}">
                            <b-nav-item @click.prevent href="#phase1" :style="{color:theme.mainColorText}">{{ $t("offer.progress.phase1") }}</b-nav-item>
                            <b-nav-item @click.prevent href="#phase2" :style="{color:theme.mainColorText}">{{ $t("offer.progress.phase2") }}</b-nav-item>
                            <b-nav-item @click.prevent href="#phase3" :style="{color:theme.mainColorText}">{{ $t("offer.progress.phase3") }}</b-nav-item>
                        </b-nav>
                    </nav>
                    <div class="header-right">
                        <div id="pdf-download">
                            <a :href="pdfUrl"><font-awesome-icon icon="file-pdf" :style="{color:theme.mainColorText}"/></a>
                        </div>

                        <div id="offer-status" class="offer-status" :class="{
                            'status-waiting': offer.offerAccepted === 0,
                            'status-success': offer.offerAccepted === 1,
                            'status-danger': offer.offerAccepted === 2
                        }">
                            {{ offerStatusText }}
                        </div>
                    </div>
                </div>

                <nav class="header-nav show-mobile">
                    <b-nav v-b-scrollspy="{offset:0}">
                        <b-nav-item href="#phase1"><span :style="{color:theme.mainColorText}">{{ $t("offer.progress.phase1") }}</span></b-nav-item>
                        <b-nav-item href="#phase2"><span :style="{color:theme.mainColorText}">{{ $t("offer.progress.phase2") }}</span></b-nav-item>
                        <b-nav-item href="#phase3"><span :style="{color:theme.mainColorText}">{{ $t("offer.progress.phase3") }}</span></b-nav-item>
                    </b-nav>
                </nav>

                <div v-if="offerIsValid" class="offer-valid-banner" :style="{ 'backgroundColor': theme.highlightColor, 'color': theme.highlightColorText }">
                    {{ $t("offer.validUntil", [$d(new Date(offer.dates.valid), 'short', 'fi-FI')]) }}
                </div>
                <div v-else class="offer-valid-banner" :style="{ 'backgroundColor': theme.highlightColor, 'color': theme.highlightColorText }">
                    {{ $t("offer.expired") }}
                </div>
            </header>

            <div id="phase1">
                <section class="offer-heading" :style="{backgroundImage:'url(' + banner + ')'}">
                    <div :class="{ 'bg-faded': theme.bannerBgType === 'banner-bg-faded' }">
                        <div :class="{
                            'container': true,
                            'bg-solid': theme.bannerBgType === 'banner-bg-solid',
                            'bg-none': theme.bannerBgType === 'banner-bg-none',
                            'align-left': theme.bannerTextAlign === 'banner-align-left',
                            'align-center': theme.bannerTextAlign === 'banner-align-center',
                            'align-right': theme.bannerTextAlign === 'banner-align-right'
                        }">
                            <h1>{{ $t("offer.title") | capitalize-first }} {{ offer.id }}</h1>
                            <p v-if="offer.dates.offer != '0000-00-00'">
                                <strong>{{ $d(new Date(offer.dates.offer), 'short', 'fi-FI') }}</strong>
                            </p>
                            <p v-id="offer.info.length > 0">{{ offer.info }}</p>
                            <p v-for="(content, index) in offer.headerTexts" :key="index">{{ content }}</p>

                            <!--<a class="scroll-link" href="#offer-content"><font-awesome-icon icon="arrow-alt-circle-down" /></a>-->
                        </div>
                    </div>
                </section>

                <section id="offer-content" class="offer-content">
                    <div class="container" v-if="Array.isArray( offer.rows ) && offer.rows.length > 0">
                        <div class="offer-content-left col-lg-6">
                            <h2>{{ offer.rows[selectedProductRowKey].title }}</h2>
                            <h3>{{ offer.rows[selectedProductRowKey].title2 }}</h3>

                            <div class="tab-rows">
                                <!--
                                <a id="product-pdf-link" href="#" @click.prevent>
                                    <font-awesome-icon icon="file-pdf" /> {{ $t("product.downloadBrochure") }}
                                </a>
                                -->
                                <b-tabs>
                                    <b-tab :title="$t('product.images') | capitalize-first" :active="true">
                                        <template v-if="
                                            offer.rows[selectedProductRowKey].info1.length > 0 ||
                                            offer.rows[selectedProductRowKey].info2.length > 0 ||
                                            offer.rows[selectedProductRowKey].info3.length > 0 ||
                                            offer.rows[selectedProductRowKey].pictures.length > 0"
                                        >
                                            <b-carousel
                                                fade
                                                :controls="hasMultipleRowImages"
                                                :indicators="hasMultipleRowImages">
                                                <b-carousel-slide v-if="offer.rows[selectedProductRowKey].info1.length > 0" :img-src="offer.rows[selectedProductRowKey].info1" />
                                                <b-carousel-slide v-if="offer.rows[selectedProductRowKey].info2.length > 0" :img-src="offer.rows[selectedProductRowKey].info2" />
                                                <b-carousel-slide v-if="offer.rows[selectedProductRowKey].info3.length > 0" :img-src="offer.rows[selectedProductRowKey].info3" />
                                                <b-carousel-slide v-for="(url, index) in offer.rows[selectedProductRowKey].pictures" :key="index" :img-src="url" />
                                            </b-carousel>
                                        </template>
                                        <template v-else>
                                            <img :src="`${productPlaceholder}`" class="img-fluid d-block mx-auto" :alt="offer.rows[selectedProductRowKey].title">
                                        </template>
                                    </b-tab>
                                    <b-tab :title="$t('product.productDetails') | capitalize-first">
                                        <div class="row-description" v-if="offer.rows[selectedProductRowKey].description.length > 0" v-html="offer.rows[selectedProductRowKey].description"/>
                                        <ul v-if="rowInfo.length > 0">
                                            <li v-for="(detail, index) in rowInfo" :key="index">
                                                <strong>{{ detail.title }}:</strong> {{ detail.content }}
                                            </li>
                                        </ul>
                                    </b-tab>
                                </b-tabs>
                            </div>
                        </div>
                        <div class="offer-content-right col-lg-6">
                            <ul>
                                <li v-for="(row, index) in offer.rows"
                                    :key="row.productCode"
                                    @click.prevent="selectProductRow(index)"
                                    :class="{ 'active': index === selectedProductRowKey }"
                                    itemtype="http://schema.org/Product">
                                    <span class="product-info">
                                        <meta itemprop="sku" :content="row.productCode" />
                                        <h4 itemprop="name">{{ row.title | capitalize-first }}</h4>
                                        <h5 v-if="row.title2.length > 0">{{ row.title2 }}</h5>
                                        <ul v-if="row.texts.length > 0" class="list-unstyled">
                                            <li v-for="(text, index) in row.texts" :key="index">
                                                {{ text.content }}
                                            </li>
                                        </ul>
                                        <span
                                            v-if="row.productCode.length > 0 || row.amount > 0"
                                            class="product-amount"
                                            :style="{ 'backgroundColor': theme.highlightColor, 'color': theme.highlightColorText }">
                                            {{ row.amount | remove-trailing-zeros | decimal-comma }} {{ row.unit }}
                                        </span>
                                        <div v-if="row.unitPrice || row.totalPrice" class="item-prices" itemtype="http://schema.org/Offer" itemprop="offers">
                                            <meta itemprop="priceValidUntil" :content="offer.dates.valid" />
                                            <meta itemprop="priceCurrency" :content="offer.invoicingCurrency" />
                                            <div v-if="row.totalPrice" class="total-price">
                                                <span itemprop="price">{{ (settings.showVat ? row.totalPrice * (row.vatPercentage / 100 + 1) : row.totalPrice) | round-two-decimals | decimal-comma }}</span><span class="currency" v-html="offerCurrency"/>
                                            </div>
                                            <div v-if="row.unitPrice" class="unit-price" >
                                                <span itemprop="priceSpecification">{{ (settings.showVat ? row.unitPrice * (row.vatPercentage / 100 + 1) : row.unitPrice) * ((100 - row.discountPercentage1) / 100) * ((100 - row.discountPercentage2) / 100) | round-two-decimals | decimal-comma }}</span><span class="currency" v-html="offerCurrency"/>
                                                <span v-if="row.unit.length > 0" class="unit">/{{ row.unit }}</span>
                                            </div>
                                        </div>
                                    </span>
                                    <span v-if="row.info1.length > 0" class="product-image">
                                        <img :src="row.info1">
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="container" v-else>
                        <p>{{ $t("noRows") }}</p>
                    </div>
                </section>
                <section class="offer-totals" :style="{ 'backgroundColor': theme.mainColor, 'color': theme.mainColorText }">
                    <div class="container">
                        <div class="offer-totals-left col-md-9">
                            {{ $t("offer.offerTotal") }}
                        </div>
                        <div class="offer-totals-right col-md-3 text-right">
                            <template v-if="!settings.showVat">
                                <span class="price-total">{{ offer.totalPrice | round-two-decimals | decimal-comma }}</span><span class="currency" v-html="offerCurrency"/>&plus; {{ $t("offer.vat") }}
                            </template>
                            <template v-if="settings.showVat">
                                <span class="price-total">{{ offer.totalPriceVat | round-two-decimals | decimal-comma }}</span><span class="currency" v-html="offerCurrency"/>
                            </template>

                            <div class="detailed-offer-prices">
                                <div class="price-row">
                                    <span class="title">{{ $t("offer.offerTotalNoVat") }}</span>
                                    <span class="price">{{ offer.totalPrice | round-two-decimals | decimal-comma }}</span><span class="currency" v-html="offerCurrency"/>
                                </div>
                                <div class="price-row" v-for="(amount, vat) in offer.vat" :key="vat">
                                    <span class="title">{{ $t("offer.vat") }} {{ vat }}%</span>
                                    <span class="price">{{ amount | round-two-decimals | decimal-comma }}</span><span class="currency" v-html="offerCurrency"/>
                                </div>
                                <div class="price-row">
                                    <span class="title">{{ $t("offer.offerTotalVat") }}</span>
                                    <span class="price">{{ offer.totalPriceVat | round-two-decimals | decimal-comma }}</span><span class="currency" v-html="offerCurrency"/>
                                </div>
                            </div>
                            <font-awesome-icon icon="angle-down" />
                        </div>
                        <!--<a class="scroll-link" href="#phase2"><font-awesome-icon icon="arrow-alt-circle-down" /></a>-->
                    </div>
                </section>
            </div>

            <section id="phase2" class="offer-details">
                <div class="container">
                    <a :href="pdfUrl" class="btn btn-default btn-block download-pdf">
                        <font-awesome-icon icon="file-pdf" /> {{ $t("offer.downloadPdf") }}
                    </a>

                    <div class="offer-detail-tabs">
                        <b-tabs>
                            <b-tab
                                :title="$t('offer.detailsTabs.offerDetails')"
                                :active="offer.sales.name.length === 0"
                            >
                                <div id="customer" class="my-3 row">
                                    <address id="invoicing-address" class="col-12 col-sm-12 col-md-6">
                                        <strong>{{ $t("offer.invoicingAddress") }}</strong><br>
                                        {{ offer.customer.invoicing.name }}<br>
                                        {{ offer.customer.invoicing.name2 }}<br>
                                        {{ offer.customer.invoicing.address }}<br>
                                        {{ offer.customer.invoicing.address2 }}<br>
                                        {{ offer.customer.invoicing.zipcode }} {{ offer.customer.invoicing.city }}
                                    </address>

                                    <address id="delivery-address" class="col-12 col-sm-12 col-md-6">
                                        <strong>{{ $t("offer.deliveryAddress") }}</strong><br>
                                        {{ offer.customer.delivery.name }}<br>
                                        {{ offer.customer.delivery.name2 }}<br>
                                        {{ offer.customer.delivery.address }}<br>
                                        {{ offer.customer.delivery.address2 }}<br>
                                        {{ offer.customer.delivery.zipcode }} {{ offer.customer.delivery.city }}
                                    </address>
                                </div>
                                <div id="additional-data" class="mb-3">
                                    <div class="table-responsive">
                                        <table class="table table-borderless">
                                            <tr v-if="offer.reference.length > 0">
                                                <td><strong>{{ $t("offer.reference") }}:</strong></td>
                                                <td>{{ offer.reference }}</td>
                                            </tr>
                                            <tr v-if="offer.customerReference.length > 0">
                                                <td><strong>{{ $t("offer.customerReference") }}:</strong></td>
                                                <td>{{ offer.customerReference }}</td>
                                            </tr>
                                            <tr v-if="offer.customerOrderNumber.length > 0">
                                                <td><strong>{{ $t("offer.customerOrderNumber") }}:</strong></td>
                                                <td>{{ offer.customerOrderNumber }}</td>
                                            </tr>
                                            <tr v-if="offer.markings.length > 0">
                                                <td><strong>{{ $t("offer.markings") }}:</strong></td>
                                                <td>{{ offer.markings }}</td>
                                            </tr>
                                            <tr v-if="offer.deliveryMethod.title.length > 0">
                                                <td><strong>{{ $t("offer.deliveryMethod") }}:</strong></td>
                                                <td>{{ offer.deliveryMethod.title }}</td>
                                            </tr>
                                            <tr v-if="offer.deliveryTerm.title.length > 0">
                                                <td><strong>{{ $t("offer.deliveryTerm") }}:</strong></td>
                                                <td>{{ offer.deliveryTerm.title }}</td>
                                            </tr>
                                            <tr v-if="offer.deliveryInfo.length > 0">
                                                <td><strong>{{ $t("offer.deliveryInfo") }}:</strong></td>
                                                <td>{{ offer.deliveryInfo }}</td>
                                            </tr>
                                            <tr v-if="offer.paymentTerm.length > 0">
                                                <td><strong>{{ $t("offer.paymentTerm") }}:</strong></td>
                                                <td>{{ offer.paymentTerm.title }}</td>
                                            </tr>
                                            <tr v-if="offer.dates.offer != '0000-00-00'">
                                                <td><strong>{{ $t("offer.dates.offer") }}:</strong></td>
                                                <td>{{ $d(new Date(offer.dates.offer), 'short', 'fi-FI') }}</td>
                                            </tr>
                                            <tr v-if="offer.dates.valid != '0000-00-00'">
                                                <td><strong>{{ $t("offer.dates.valid") }}:</strong></td>
                                                <td>{{ $d(new Date(offer.dates.valid), 'short', 'fi-FI') }}</td>
                                            </tr>
                                            <tr v-if="offer.dates.accepted != '0000-00-00'">
                                                <td><strong>{{ $t("offer.dates.accepted") }}:</strong></td>
                                                <td>{{ $d(new Date(offer.dates.accepted), 'short', 'fi-FI') }}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab
                                v-if="offer.sales.name.length > 0"
                                :title="$t('offer.detailsTabs.askMore')
                            ">
                                <div id="offerContactUs" class="my-3">
                                    <b-form-textarea
                                        v-model="contact.message"
                                        :rows="3"
                                        :max-rows="6">
                                    </b-form-textarea>

                                    <div class="clearfix"></div>

                                    <button
                                        @click.prevent="sendContactEmail"
                                        :disabled="contact.message.length <= 0"
                                        class="btn btn-primary"
                                        :style="{ 'backgroundColor': theme.highlightColor, 'color': theme.highlightColorText }">
                                        {{ $t("offer.contact.send") }}
                                    </button>
                                </div>
                            </b-tab>
                            <b-tab
                                v-if="offer.sales.name.length > 0"
                                :title="$t('offer.detailsTabs.acceptOffer')"
                                :active="offer.sales.name.length > 0"
                            >
                                <div v-if="offerIsValid" id="signature" class="my-3">
                                    <div v-if="offer.offerAccepted === 0" class="pad">
                                        <p>{{ $t("offer.signature.yourSignature") }}:</p>
                                        <canvas id="signature-wide" class="signature" width="600"></canvas>
                                        <canvas id="signature-mobile" class="signature" width="300"></canvas>
                                        <button id="clear-canvas" @click="clearSignature" type="button" class="btn btn-default"><font-awesome-icon icon="times" /></button>
                                    </div>
                                    <div v-else class="pad">
                                        <p>{{ $t("offer.signature.title") }}:</p>
                                        <img :src="offer.signature" class="signature" alt="signature">
                                    </div>

                                    <div id="printed-name">
                                        <template v-if="offer.offerAccepted == 0">
                                            <b-form-input v-model="offer.printedName" type="text" :placeholder="$t('offer.signature.printedName')"></b-form-input>
                                        </template>
                                        <template v-else>
                                            <p>{{ offer.printedName }}</p>
                                        </template>
                                    </div>
                                </div>
                                <div v-else id="signature" class="my-3">
                                    <div v-if="offer.offerAccepted === 1" class="pad">
                                        <p>{{ $t("offer.signature.title") }}:</p>
                                        <img :src="offer.signature" class="signature" alt="signature">
                                    </div>

                                    <div v-if="offer.printedName.length > 0" id="printed-name">
                                        <p>{{ offer.printedName }}</p>
                                    </div>
                                </div>

                                <div v-if="offerIsValid" id="actions" class="mb-3">
                                    <button
                                        v-if="offer.offerAccepted == 0"
                                        @click.prevent="acceptOffer"
                                        :disabled="offer.signature.length <= 0 || offer.printedName.length <= 0"
                                        id="accept"
                                        class="btn btn-primary"
                                        :style="{ 'backgroundColor': theme.highlightColor, 'color': theme.highlightColorText }">
                                        {{ $t("offer.accept") }}
                                    </button>
                                    <div
                                        v-if="offer.signature.length <= 0 || offer.printedName.length <= 0"
                                        class="w-100 d-flex justify-content-center">
                                        <div class="alert alert-warning">{{ $t("offer.acceptAlert") }}</div>
                                    </div>
                                    <a
                                        v-if="offer.offerAccepted == 0"
                                        id="reject"
                                        class="mt-1"
                                        href="#"
                                        @click.prevent="reject.show=true"
                                    >{{ $t("offer.reject") }}</a>
                                </div>
                            </b-tab>
                        </b-tabs>

                        <!--<a class="scroll-link" href="#phase3"><font-awesome-icon icon="arrow-alt-circle-down" /></a>-->
                    </div>
                </div>
            </section>

            <section id="phase3" class="offer-contact">
                <div class="container">
                    <div class="offer-contact-inner row">
                        <div class="title" :style="{backgroundColor:theme.mainColor, color:theme.mainColorText}">{{ $t("offer.salesInfo.title") }}</div>
                        <div class="contact-info col-12 col-sm-6">
                            <div class="intro">{{ $t("offer.salesInfo.intro") }}</div>
                            <div class="contacts">
                                <address>
                                    <template v-if="offer.sales.name.length > 0">
                                        {{ offer.sales.name }}<br>
                                    </template>
                                    <template v-if="offer.sales.phone.length > 0">
                                        <font-awesome-icon icon="phone" /> {{ offer.sales.phone }}<br>
                                    </template>
                                    <template v-if="offer.sales.email.length > 0">
                                        <font-awesome-icon icon="envelope" /> <a :href="'mailto:' + offer.sales.email">{{ offer.sales.email }}</a>
                                    </template>
                                </address>
                            </div>
                            <hr>
                            <div class="company-info">
                                <address>
                                    <template v-if="info.name.length > 0">
                                        {{ info.name }}<br>
                                    </template>
                                    <template v-if="info.vat.length > 0">
                                        {{ info.vat }}<br>
                                    </template>
                                    <template v-if="info.address1.length > 0">
                                        {{ info.address1 }}<br>
                                    </template>
                                    <template v-if="info.address2.length > 0">
                                        {{ info.address2 }}<br>
                                    </template>
                                    <template v-if="info.email.length > 0">
                                        <font-awesome-icon icon="envelope" /> <a :href="'mailto:' + info.email">{{ info.email }}</a>
                                    </template>
                                </address>
                            </div>
                        </div>
                        <div class="contact-picture col-12 col-sm-6">
                            <template v-if="this.offer.sales.picture.length > 0">
                                <img :src="`${salesPicture}`" class="img-fluid" :alt="offer.sales.name">
                            </template>
                        </div>
                    </div>
                </div>
            </section>
            <section id="powered">
                <p class="text-center">
                    Powered by <a href="https://www.oscar.fi" target="_blank"><img src="@/assets/oscar_logo_r.png" alt="Oscar Software Oy"></a>
                </p>
            </section>
        </div>
        <div v-else class="offer m-3 p-3 border rounded">
            <div class="text-center">
                <font-awesome-icon icon="spinner" pulse />
            </div>
        </div>

        <div id="modals">
            <b-modal id="accept-modal" v-model="showOfferAcceptModal">
                <template v-if="offer.offerAccepted">
                    {{ $t("offer.acceptSuccess") }}
                </template>
                <template v-else>
                    {{ $t("offer.acceptFailure") }}
                </template>
            </b-modal>
            <b-modal id="contact-modal" v-model="contact.showModal">
                <template v-if="contact.sendOk">
                    {{ $t("offer.contact.feedbackSuccess") }}
                </template>
                <template v-else>
                    {{ $t("offer.contact.feedbackFailure") }}
                </template>
            </b-modal>
            <b-modal id="reject-modal" :title="$t('offer.modals.reject.title')" v-model="reject.show" hide-footer>
                <p>{{ $t("offer.modals.reject.content") }}</p>
                <b-form-textarea
                    v-model="reject.message"
                    :rows="3"
                    :max-rows="6">
                </b-form-textarea>
                <b-button class="mt-3" @click.prevent="reject.show=false">{{ $t("offer.modals.reject.cancel") }}</b-button>
                <b-button class="mt-3 ml-1" @click.prevent="sendRejectEmail">{{ $t("offer.modals.reject.ok") }}</b-button>
            </b-modal>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import SignaturePad from 'signature_pad'

export default {
  name: 'Offer',
  data () {
    return {
      isLoaded: false, // Is offer loaded from DB.
      offer: {}, // Offer details from DB.
      contact: { // Contact details from user input.
        message: '', // Message typed by user.
        sendOk: false, // Is message sent ok.
        showModal: false // Is the contact feedback modal visible.
      },
      reject: {
        show: false,
        message: '', // Message typed by user.
        sendOk: false // Is message sent ok.
      },
      baseUrl: process.env.VUE_APP_SERVER_BASE,
      showOfferAcceptModal: false, // Is the accept feedback modal visible.
      selectedProductRowKey: 0, // Currently selected offer row.
      pad: null, // Signature pad.
      pad_mobile: null // Signature pad for mobile layout.
    }
  },
  computed: {
    // Get company info from store.
    info () {
      return this.$store.getters.getInfo
    },
    // Get customer theme from store.
    theme () {
      return this.$store.getters.getTheme
    },
    // Get customer logo from store.
    logo () {
      let path = this.$store.getters.urlPath + 'static/uploads/'
      return path + this.$store.getters.getImages.logo
    },
    // Get sales person picture.
    salesPicture () {
      let path = this.$store.getters.urlPath + 'static/uploads/'
      return path + this.offer.sales.picture
    },
    // Get customer banner from store.
    banner () {
      let path = this.$store.getters.urlPath + 'static/uploads/'
      return path + this.$store.getters.getImages.banner
    },
    // Get customer banner from store.
    productPlaceholder () {
      let path = this.$store.getters.urlPath + 'static/uploads/'
      return path + this.$store.getters.getImages.product
    },
    // Get setting for showing VAT
    settings () {
      return this.$store.getters.getSettings
    },
    // Get offer currency symbol if available.
    offerCurrency () {
      if (this.offer.invoicingCurrency === 'EUR') {
        return '&euro;'
      } else if (this.offer.invoicingCurrency === 'USD') {
        return '&dollar;'
      } else if (this.offer.invoicingCurrency === 'GBP') {
        return '&pound;'
      } else if (this.offer.invoicingCurrency === 'JPY') {
        return '&yen;'
      }
      return this.offer.invoicingCurrency
    },
    // Get text representation for offer accepted status (yes/no).
    offerAccepted () {
      return this.offer.offerAccepted === 1 ? this.$t('commons.yes') : this.$t('commons.no')
    },
    // Get offer valid status. Is valid if expire date is in the future.
    offerIsValid () {
      let validDate = new Date(this.offer.dates.valid)
      let today = new Date()
      today.setHours(0, 0, 0, 0)
      return validDate.valueOf() >= today.valueOf()
    },
    // Count days left until offer expires.
    validDaysLeft () {
      let today = new Date()
      let valid = new Date(this.offer.dates.valid)
      let day = 1000 * 60 * 60 * 24

      return Math.ceil((valid.getTime() - today.getTime()) / (day))
    },
    // Get text representation for offer status (accepted/rejected/pending).
    offerStatusText () {
      if (parseInt(this.offer.offerAccepted) === 1) {
        return this.$t('offer.status.accepted')
      } else if (parseInt(this.offer.offerAccepted) === 2) {
        return this.$t('offer.status.rejected')
      } else {
        return this.$t('offer.status.pending')
      }
    },
    // Get URL to offer PDF
    pdfUrl () {
      return this.$store.getters.urlPath + 'services/getOfferPDF.php?offer=' + this.offer.hash
    },
    // Get filled additional infos from active row
    rowInfo () {
      let filteredRows = []
      let arows = this.offer.rows[this.selectedProductRowKey].additionals

      for (let key in arows) {
        if (arows.hasOwnProperty(key)) {
          let arow = arows[key]
          let rowData = {}
          for (let key2 in arow) {
            if (arow.hasOwnProperty(key2)) {
              rowData[key2] = arow[key2]
            }
          }
          if (rowData.hasOwnProperty('content') && rowData.content.length > 0) {
            filteredRows.push(rowData)
          }
        }
      }

      return filteredRows
    },
    hasMultipleRowImages () {
      let i1 = this.offer.rows[this.selectedProductRowKey].info1
      let i2 = this.offer.rows[this.selectedProductRowKey].info2
      let i3 = this.offer.rows[this.selectedProductRowKey].info3
      let p = this.offer.rows[this.selectedProductRowKey].pictures

      return (
        (i1.length > 0 && i2.length > 0) ||
        (i1.length > 0 && i3.length > 0) ||
        (i2.length > 0 && i3.length > 0) ||
        (i1.length > 0 && p.length > 0) ||
        (i2.length > 0 && p.length > 0) ||
        (i3.length > 0 && p.length > 0) ||
        p.length > 1
      )
    }
  },
  methods: {
    // Load offer details from services.
    loadOffer (id) {
      let me = this
      axios.get(me.$store.getters.urlPath + 'services/getOffer.php?offer=' + id)
        .then((response) => {
          if (!Array.isArray(response.data)) {
            me.offer = response.data
            this.offer.offerAccepted = parseInt(this.offer.offerAccepted)
            me.$store.dispatch('setBackendId', response.data.backendId).then(() => {
              me.isLoaded = true
            })
          } else {
            me.$router.push({ name: '404' })
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
        })
    },
    // Set currently selected offer row.
    selectProductRow (key) {
      if (this.offer.rows[key].productCode.length > 0 || this.offer.rows[key].amount > 0) {
        this.selectedProductRowKey = key
      }
    },
    // Call services to set offer status to acceted.
    acceptOffer () {
      let me = this
      axios.post(me.$store.getters.urlPath + 'services/acceptOffer.php', {
        hash: me.offer.hash,
        signature: me.offer.signature,
        printedName: me.offer.printedName
      })
        .then((response) => {
          if (response.data.length === 0) {
            me.$router.push({ name: '404' })
          } else {
            me.offer.offerAccepted = parseInt(response.data)
            if (me.offer.offerAccepted === 1) {
              let today = new Date()
              me.offer.dates.accepted = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
            }
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
        })
        .then(function () {
          me.showOfferAcceptModal = true
        })
    },
    sendContactEmail () {
      let me = this
      axios.post(me.$store.getters.urlPath + 'services/sendContactEmail.php', {
        hash: me.offer.hash,
        message: me.contact.message
      })
        .then((response) => {
          if (response.data.length === 0) {
            me.$router.push({ name: '404' })
          } else {
            // show feedback
            me.contact.sendOk = response.data
          }
        })
        .catch((error) => {
          me.contact.sendOk = false
          // eslint-disable-next-line
          console.log(error)
        })
        .then(function () {
          me.contact.showModal = true
          me.contact.message = ''
        })
    },
    sendRejectEmail () {
      let me = this
      axios.post(me.$store.getters.urlPath + 'services/sendRejectEmail.php', {
        hash: me.offer.hash,
        message: me.reject.message
      })
        .then((response) => {
          if (response.data.length === 0) {
            me.$router.push({ name: '404' })
          } else {
            // show feedback
            me.reject.sendOk = response.data
          }
        })
        .catch((error) => {
          me.reject.sendOk = false
          // eslint-disable-next-line
          console.log(error)
        })
        .then(function () {
          me.reject.show = false
          me.reject.message = ''
        })
    },
    // Initialize signature pad.
    // Must be called after DOM is loaded.
    createSignatureCanvas () {
      if (this.offer.offerAccepted === 0 && this.offerIsValid) {
        let canvas = document.querySelector('#signature-wide')
        let ratio = Math.max(window.devicePixelRatio || 1, 1)
        canvas.getContext('2d').scale(ratio, ratio)

        let me = this
        me.pad = new SignaturePad(canvas, {
          onEnd: () => {
            me.offer.signature = me.pad.toDataURL()
          }
        })

        let canvasMobile = document.querySelector('#signature-mobile')
        let ratioMobile = Math.max(window.devicePixelRatio || 1, 1)
        canvasMobile.getContext('2d').scale(ratioMobile, ratioMobile)

        me.pad_mobile = new SignaturePad(canvasMobile, {
          onEnd: () => {
            me.offer.signature = me.pad_mobile.toDataURL()
          }
        })
      }
    },
    // Clears signature pad canvas.
    clearSignature () {
      this.pad.clear()
      this.pad_mobile.clear()
      this.offer.signature = ''
    }
  },
  watch: {
    isLoaded (val) {
      // Wait for DOM to load
      this.$nextTick(function () {
        // Create canvas for signature
        this.createSignatureCanvas()

        // Create more complicated customized styles
        let style = document.createElement('style')
        style.type = 'text/css'
        style.appendChild(document.createTextNode(''))
        style.childNodes[0].textContent = '.header-nav ul li:after, .logo:after { border-left-color:' + this.theme.mainColor + '; }'
        document.head.appendChild(style)
      })
    }
  },
  created () {
    this.loadOffer(this.$route.params.id)
  }
}
</script>

<style lang="scss">
#powered img {
    max-height: 25px;
}
</style>
